import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import axios from "axios";
import { Spin } from "antd";
import { axiosErrorHandler } from "../../../../swzutils";
import FormattedAddress from "../../components/FormattedAddress";
const SenderReceiverAddressPanel = ({ senderReceiverId, onLoad }) => {
    const [loading, setLoading] = React.useState(false);
    const [senderReceiver, setSenderReceiver] = React.useState();
    useEffect(() => {
        if (senderReceiverId) {
            loadSenderReceiver();
        }
    }, [senderReceiverId]);
    const loadSenderReceiver = () => {
        setLoading(true);
        axios.get(`/admin/v1/sender-receivers/${senderReceiverId}`)
            .then((response) => {
            setSenderReceiver(response.data);
            onLoad?.(response.data);
        })
            .catch((error) => {
            axiosErrorHandler(error);
        })
            .finally(() => {
            setLoading(false);
        });
    };
    return (_jsx(Spin, { spinning: loading, delay: 500, children: _jsx(FormattedAddress, { companyName: senderReceiver?.companyName, contactName: senderReceiver?.contactName, contactTelephone: senderReceiver?.contactTelephone, contactEmail: senderReceiver?.contactEmail, address: senderReceiver?.address, uhfChannelOffice: senderReceiver?.uhfChannelOffice, uhfChannelLoader: senderReceiver?.uhfChannelLoader }) }));
};
export default SenderReceiverAddressPanel;
